export const EventsGTM = {
  SIDE_BAR_BUTTON: 'click-sidebar-button',
  CLICK_CREATE_EVALUATION: 'click_create_evaluation',
  CREATE_CUSTOM_QUESTION: 'click_add_custom_question',
  CHANGE_CUSTOM_QUESTION_TYPE: 'click_custom_question',
  ERROR_LOGIN_PARTNER: 'partner-get-me-error',
  CONTACT_ALKYMER_DETAILS: 'Contact-Alkymer-details',
  CONTACT_PROFILE_LIST: 'Contact-profile-list',
  SEARCH_TEST_BY_TEXT: 'Search-test-by-text',
  SEARCH_TESTGROUP: 'Search-testgroup',
  SEARCH_TESTGROUP_NEED_ANOTHER_TEST: 'suggest-test-link',
  SEARCH_SEND_EMAIL: 'search-send-email',
  EDIT_EMAIL_TEMPLATE: 'edit-email-template',
  EVALUATION_COPY_LINK: 'evaluation-copy-link',
  SEARCH_VIEW_STATISTICS: 'search-statistics',
  ADD_CANDIDATES_TO_EVALUATION: 'evaluation-dashboard-add-candidates',
  SHARE_DASHBOARD: 'share-dashboard',
  REPORTS_PARTNERS: 'reports-partners',
  NPS_SUBMITTED: 'nps-submitted',
  PROFILE_VIDEO_REVIEW: 'Profile-Video',
};
